// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";

export default function EmbedSpotify({ styles, url, caption }) {
    const urlFormatted = url.replace("https://", "//");
    return (
        <div className={styles.embedSpotify}>
            <iframe
                src={urlFormatted}
                width={"100%"}
                height={"380"}
                frameBorder={"0"}
                allowtransparency={"true"}
                allow={"encrypted-media"}
                title={caption}
            />
            <p>{caption}</p>
        </div>
    );
}

EmbedSpotify.propTypes = {
    caption: PropTypes.string,
    styles: PropTypes.object,
    url: PropTypes.string,
};
